import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import Home from '../pages/home/Home';
import RefreshLogin from '../pages/auth/refresh/RefreshLogin';
import SsoCallback from '../pages/auth/login/SsoCallback';

export default () => (
  <Fragment>
    <Route exact path="/auth" component={Home} />
    <Route exact path="/refresh/:token" component={RefreshLogin} />
    <Route exact path="/auth/sso/callback" component={SsoCallback} />
  </Fragment>
);